<template>
    <div>
        <card-header title='New Application' icon="fa-plus"/>

        <card-body>
            <application-form :card="card" :application="application"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!application.title"
                    ><i class="fas fa-plus mr-2"></i>New Application</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import ApplicationForm from "./ApplicationForm.vue";

    import {client as http} from '../../http_client';

    export default {
        components: {CardHeader, CardToolbar, CardBody, CardFooter, ApplicationForm},
        props: ['card'],
        data() {
            return {
                application: {}
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);
                http.post('applications/', this.application, {force: true}).then(response => {
                    this.$reloadCard('applications');
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            }
        }
    }
</script>
